import styled from "styled-components";

const ErrorMessage = styled.div`
  color: ${(props) => props.theme.colors.danger};

  font-size: ${(props) => props.theme.fontSizes.xs}px;
`;

export default ErrorMessage;
